enum WasteStreamTypeEnum {
  BIO = 1,
  ELECTRONICS = 2,
  GLASS = 3,
  METAL = 4,
  PLASTIC = 5,
  PAPER = 6,
  RESIDUAL = 7,
  WOOD = 8,
}

export default WasteStreamTypeEnum;
